/**
 * COMMERCE-WORKSPACE-000002 — domain sync freshness for Founder meta bar.
 * Read-only: commerce sync health API. No scheduler redesign.
 */
import { useEffect, useState } from 'react';
import {
  amazonConnectApi,
  type CommerceSyncHealth,
  type CommerceSyncHealthRow,
} from '../../../api/amazonconnect';

export function useCommerceDomainHealth(connectionId: string, marketsyncDomain: string) {
  const [health, setHealth] = useState<CommerceSyncHealth | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!connectionId) {
      setHealth(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    void amazonConnectApi
      .commerceSyncHealth(connectionId)
      .then((h) => {
        if (!cancelled) setHealth(h);
      })
      .catch(() => {
        if (!cancelled) setHealth(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [connectionId]);

  const row: CommerceSyncHealthRow | undefined = health?.domains?.find(
    (d) => d.marketsync_domain === marketsyncDomain || d.key === marketsyncDomain,
  );

  return {
    health,
    row,
    loading,
    lastSync: row?.last_sync_at,
    amazonCount: row?.records_received,
    dbHint: row?.records_persisted,
    quality: row?.quality,
    realtimeEligible: row?.realtime_eligible,
    status: row?.status,
  };
}
